var _path, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgency3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_898_1315",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 4,
    width: 20,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 4.5H3V24.5H23V4.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_898_1315)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0103 9.39069C15.0103 12.0917 13.1487 14.2813 10.8526 14.2813C8.5565 14.2813 6.69502 12.0917 6.69496 9.39069C6.69496 6.68965 7.3061 4.5 10.8526 4.5C14.3989 4.5 15.0103 6.68965 15.0103 9.39069ZM13.1294 14.6566C17.9849 15.5053 18.6194 16.846 18.6964 21.5513C18.7013 21.8523 18.7039 21.9043 18.7053 21.8774C18.7051 21.9571 18.705 22.0745 18.705 22.2431C18.705 22.2431 17.5489 24.5 10.8527 24.5C4.15665 24.5 3.00063 22.2431 3.00063 22.2431C3.00063 21.9806 3.00025 21.8301 3 21.7487C3.00131 21.7922 3.00463 21.7726 3.01183 21.3984C3.10031 16.8169 3.77354 15.4959 8.57612 14.6566C8.57612 14.6566 9.25962 15.5 10.8527 15.5C12.4457 15.5 13.1294 14.6566 13.1294 14.6566ZM16.6224 13.4081C18.4873 13.4081 19.9991 11.6297 19.9991 9.43604C19.9991 7.24227 19.5028 5.4639 16.6224 5.4639C16.1379 5.4639 15.721 5.51438 15.3624 5.60863C16.0276 6.79639 16.1188 8.23907 16.1188 9.39065C16.1188 10.6945 15.7539 11.9394 15.0817 12.9701C15.5437 13.2495 16.0672 13.4081 16.6224 13.4081ZM18.4714 13.7128C22.415 14.4022 22.9303 15.4911 22.9928 19.3126C22.9967 19.5587 22.9989 19.5996 23 19.5768C22.9998 19.6416 22.9998 19.7364 22.9998 19.8746C22.9998 19.8746 22.456 20.9349 19.8029 21.4426C19.7577 18.9473 19.5387 17.2488 18.5866 15.9843C18.0359 15.2529 17.288 14.7531 16.4659 14.3941C16.5169 14.3964 16.5688 14.3979 16.6223 14.3979C17.9162 14.3979 18.4714 13.7128 18.4714 13.7128Z",
    fill: "#222939"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2857 6.125C25.8286 6.125 25.4857 6.29375 25.1429 6.575L23.3143 5.5625C23.3714 5.39375 23.4286 5.16875 23.4286 5C23.4286 4.83125 23.3714 4.60625 23.3143 4.4375L25.1429 3.425C25.4857 3.70625 25.8286 3.875 26.2857 3.875C27.2571 3.875 28 3.14375 28 2.1875C28 1.23125 27.2571 0.5 26.2857 0.5C25.3143 0.5 24.5714 1.23125 24.5714 2.1875C24.5714 2.3 24.5714 2.35625 24.5714 2.46875L22.5714 3.5375C22.3429 3.425 22.0571 3.3125 21.7143 3.3125C20.8 3.3125 20 4.04375 20 5C20 5.9 20.8 6.6875 21.7143 6.6875C22.0571 6.6875 22.3429 6.575 22.5714 6.4625L24.5714 7.53125C24.5714 7.64375 24.5714 7.7 24.5714 7.8125C24.5714 8.76875 25.3143 9.5 26.2857 9.5C27.2571 9.5 28 8.76875 28 7.8125C28 6.85625 27.2571 6.125 26.2857 6.125Z",
    fill: "#222939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgency3);
export default __webpack_public_path__ + "static/media/agency-3.4f69fb1935b32185432518976f9cb50c.svg";
export { ForwardRef as ReactComponent };